// extracted by mini-css-extract-plugin
export var alertIcon = "_q0-0";